import { NgIf } from '@angular/common';
import { Directive, inject, OnInit } from '@angular/core';
import { Acl } from '@df/core/service/acl';

/**
 * Use this directive to present element only in developer mode.
 *
 * ```html
 * <div *ifDev>...</div>
 * ```
 */
@Directive({
    selector: '[ifDev]',
    standalone: true
})
export class IfDevDirective extends NgIf implements OnInit {
    private acl = inject(Acl);

    /**
     * Sets condition depending on user being developer.
     *
     * @memberof IfDevDirective
     */
    ngOnInit() {
        this.ngIf = this.acl.isDeveloper;
    }
}
